@if (node) {
  <div class="drag-drop-tree"
    [ngClass]="{'top':node?.id==='top'}"
    [style.display]="node?.id==='top' || expandedNodes?.[node.id || node.title] ? 'block' : 'none'">
    <ng-container>
      <div
        (cdkDropListDropped)="drop($event)"
        [cdkDropListConnectedTo]="dragDropService.dropLists"
        [cdkDropListEnterPredicate]="allowDropPredicate"
        [id]="node.id"
        [cdkDropListData]="node.contents"
        [cdkDropListDisabled]="!editMode"
        cdkDropList
        class="draggable-list">
        @for (child of node.contents; track child; let i = $index) {
          <div
            cdkDrag
            [cdkDragData]="child"
            (cdkDragStarted)="onDragStarted($event)"
            [cdkDragDisabled]=""
            [cdkDragPreviewClass]="'folderDragPreview'"
            (cdkDragMoved)="dragMoved($event)"
            (cdkDragReleased)="dragReleased($event)"
            class="draggable-list-item mat-tree-node"
            [ngClass]="{'folder':child.type===0}">
            @if (child.type === 0 && child.menu_entry_count) {
              <div class="parent-folder-node">
                @if (editMode) {
                  <div class="drag-handle" cdkDragHandle>☰</div>
                }
                <button class="folder-toggle"
                  (click)="onNodeToggled(child)">
                  <i [ngClass]="expandedNodes[child.id || child.title] ? 'chevron-up' : 'chevron-down'"></i>
                  @if (child.type === 0) {
                    <span>{{child.folder.attributes.name}}</span>
                  }
                </button>
              </div>
              <dragdrop-tree [node]="child" [expandedNodes]="expandedNodes">
              </dragdrop-tree>
            }
            @if (child.type===1) {
              <div class="menu-node row"
                [style.display]="child.visible ? 'flex' : 'none'">
                @if (editMode) {
                  <div class="drag-handle" cdkDragHandle>☰</div>
                }
                <a [routerLink]="!isDragging ? 'view/page_view/' + child.session_state.id : null"
                (click)="!isDragging && closeSidenav()">{{child.session_state.attributes.name}}</a>
              </div>
            }
          </div>
        }
      </div>
    </ng-container>
  </div>
}
